import RibbonsUtil from "../../utils/RibbonsUtil";
import * as api from "../../requests/loader";
import { typeDetails } from  "./player-controls-user";
import Device from '../../devices/device';
export const ADD_TO_CONTEXT_MENU = 'ADD_TO_CONTEXT_MENU';
export const TOGGLE_CONTEXT_MENU = 'TOGGLE_CONTEXT_MENU';
export const UPDATE_FAVORITES_MUSIC_LIST = 'UPDATE_FAVORITES_MUSIC_LIST';
export const ADD_FAVORITES_MUSIC_LIST = 'ADD_FAVORITES_MUSIC_LIST';
export const SHOW_ALERT_HEADER = 'SHOW_ALERT_HEADER';

class MusicUtils{
  static async getPlaylistDetailFromCard(playlistId,user) {
    let musicRb = new RibbonsUtil();
    return new Promise((resolve, reject) => {
      musicRb.getMusicListFromApi(`playlistSTV/${playlistId}`, user, { countryCode: user.countryCode }).then(
        (resp) => {
          resolve(resp.playlistDetail.playlistDetail);
        }
      ).catch(
        (err) => {
          console.log("cant get the playlistid" + err);
          reject(err);
        }
      );
    });
  }

  static async getAlbumDetailFromCard(albumId,user) {
    const musicRb = new RibbonsUtil();
    return new Promise((resolve, reject) => {
      musicRb.getMusicListFromApi(`albumSTV/${albumId}`, user, { countryCode: user.countryCode }).then(
        (resp) => {
          const volumes = resp.albumDetail.volumes;
          const tracks = [];
          let trackIndex=0;
          volumes.map(volume => {
            volume.tracks.map(track => {
                trackIndex++;
                tracks.push({...track, trackNumber: trackIndex});
              }
            );
          });
          resolve(tracks);
        }
      ).catch(
        (err) => {
          console.log("cant get the playlistid" + err);
          reject(err);
        }
      );
    });
  }

  static async getRadioDetailFromCard(stationId,user) {
    const musicRb = new RibbonsUtil();
    return new Promise((resolve, reject) => {
      musicRb.getMusicListFromApi(`/stationSTV/detail/${stationId}`, user, {
        countryCode: user.countryCode
      }).then(
        (resp) => {
          resolve(resp);
        }
      ).catch(
        (err) => {
          console.log("cant get the radio detail" + err);
          reject(err);
        }
      );
    });
  }

  static async getRadioDetailUrl(stationId, user) {
    const musicRb = new RibbonsUtil();
    return new Promise((resolve, reject) => {
      musicRb
        .getMusicListFromApi(`/stationSTV/detail/${stationId}`, user, {
          countryCode: user.countryCode
        })
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          console.log(`cant get the radio detail${err}`);
          reject(err);
        });
    });
  }

  static async toggleFavorite(content, user){
    const musicService = new RibbonsUtil();
    return new Promise((resolve, reject) => {
      switch (content.type) {
        case "playlist":
          const playlistDetail = content;
          const playlistId = playlistDetail.id;
          let el = document.getElementById(`fav-${playlistId}`);
          if (!playlistDetail.isFollowing) {
            el.classList.add("favorited");
            musicService.getMusicListFromApi(`favorites/followPlaylistSTV/${playlistId}`, user, { countryCode: user.countryCode }).then(
              (resp) => {
                if (resp.success) { resolve(true);}
                else { resolve(false); }
              }
            ).catch( (err) => {
                el.classList.remove("favorited");
                reject(false);
              }
            );
          } else {
            el.classList.remove("favorited");
            musicService.getMusicListFromApi(`favorites/unfollowPlaylistSTV/${playlistId}`, user, { countryCode: user.countryCode }).then(
              (resp) => {
                if (resp.success) {
                  resolve(false);
                } else {
                  resolve(true);
                }
              }
            ).catch(
              (err) => {
                console.log("Error:",err);
                reject(true);
              }
            );
          }
          break;
        case "radio":
          //addRadioSTV
          const radio = content;
          const radioId = radio.id;
          const fromPlayer = (radio.fromPlayer) ? true : false;
          if(!fromPlayer) { el = document.getElementById(`fav-${radioId}`); }
          if (!radio.isFavorite) {
            if(!fromPlayer) {
              el.classList.add("favorited"); }
            musicService.getMusicRadioFromApi(`middleware/user/followRadio`, user, { contentId: radioId, countryCode: user.countryCode }).then(
              (resp) => {
                if (resp.response==="success") { resolve(true);}
                else { resolve(false); }
              }
            ).catch( (err) => {
                el.classList.remove("favorited");
                reject(false);
              }
            );
          } else {
            if(!fromPlayer) { el.classList.remove("favorited"); }
            musicService.getMusicListFromApi(`favorites/removeRadioSTV/${radioId}`, user, { countryCode: user.countryCode }).then(
              (resp) => {
                if (resp.response==="success") {
                  resolve(false);
                } else {
                  resolve(true);
                }
              }
            ).catch(
              (err) => {
                console.log("Error:",err);
                reject(true);
              }
            );
          }
          break;
        case "album":
          //addRadioSTV
          const album = content;
          const albumId = album.albumId || album.id;

          el = document.getElementById(`fav-${albumId}`);
          if(album.isFavorite) el.classList.remove("favorited");
          else el.classList.add("favorited");

          musicService.getMusicListFromApi(`favorites/toggleAlbumSTV/${albumId}`, user, { countryCode: user.countryCode }).then(
            (resp) => {
              if (resp.favorite==='favorite') { resolve(true);}
              else { resolve(false); }
            }
          ).catch( (err) => {
              if(album.isFavorite) el.classList.add("favorited");
              else el.classList.remove("favorited");
              reject(false);
            }
          );
          break;
        case "artist":
          const artist = content;
          const artistId = artist.id;

          el = document.getElementById(`fav-${artistId}`);
          if(el !== null){
            if(artist.isFavorite) el.classList.remove("favorited");
            else el.classList.add("favorited");
          }

          musicService.getMusicListFromApi(`favorites/toggleArtistSTV/${artistId}`, user, { countryCode: user.countryCode }).then(
            (resp) => {
              if (resp.favorite==="favorite") { resolve(true);}
              else { resolve(false); }
            }
          ).catch( (err) => {
              if(album.isFavorite) el.classList.add("favorited");
              else el.classList.remove("favorited");
              reject(false);
            }
          );
          break;
        case "song":
          const contentId = content.id;
          musicService.getMusicListFromApi(`favorites/toggleSongSTV/${contentId}`,user,{countryCode: user.countryCode}).then(
            (resp) => {
              if (resp.favorite==="favorite") {
                resolve("favorite");
              }
              else if (resp.favorite==="unfavorite") {
                resolve("unfavorite");
              }
              else {
                resolve(false);
              }

            }
          ).catch((err) => {
              reject(false);
            }
          );
          break;
        default:
          reject(false);
      }
    });
  }

  static getPgmFromState(currentMusic, type){
    let detailsPgm;
    if(currentMusic){
      if(type === 'radio'){
        detailsPgm = {
          type:         'radio',
          radioName:    currentMusic.name,
          radioStation: currentMusic.dial + currentMusic.band
        }
      } else {
        detailsPgm = {
          type: typeDetails(currentMusic.songSourceType),
          playlistName: currentMusic.playlistName,
          songName: currentMusic.name,
          songNumber: currentMusic.trackNumber,
          albumName: currentMusic.albumName,
          artistName: currentMusic.artist
        };
      }
    }

    const myPgm = currentMusic ? {
      media:{
        content_id: currentMusic.id,
        video_url: currentMusic.url,
        duration: currentMusic.durationInSeconds,
        streamType: (type === 'radio') ? 'radio' : 'audio',
        backgroundImage: null,
        isLive: (type === 'radio') ? true : false,
        isActiveEpg: false,
        details: detailsPgm,
      }
    } : '';

    return myPgm;
  }


  static async checkSinglePlay(user){
    let musicRb = new RibbonsUtil();
    return new Promise((resolve, reject) => {
      musicRb.getMusicCheckSinglePlay(user.cm_access_token).then(
        (resp) => {
          resolve(resp);
        }
      ).catch(
        (err) => {
          console.log(`cant get checkSinglePlay${err}`);
          reject(err);
        }
      );
    });
  }

  static async sendMetrics(data, user){
    const musicRb = new RibbonsUtil();
    return new Promise((resolve, reject) => {
      musicRb.getMusicListFromApi('player/metrics', user, { id: data.id, metricType: data.metricType, isStarted: data.isStarted, duration: data.duration, timestamp: data.timestamp, playlistId: data.playlistId, countryCode: user.countryCode }).then(
        (resp) => {
          resolve(resp);
        }
      ).catch(
        (err) => {
          console.log("cant process metrics detail" + err);
          reject(err);
        }
      );
    });
  }

  static async setupPlay(user){
    let musicRb = new RibbonsUtil();
    return new Promise((resolve, reject) => {
      musicRb.getMusicSetupPlay(user.cm_access_token).then(
        (resp) => {
          console.log("-----------setUpPlay", resp);
          resolve(resp);
        }
      ).catch(
        (err) => {
          console.log("cant get setupPlay" + err);
          reject(err);
        }
      );
    });
  }

  static transformStringrayRadios(radios, filterId){
    if(Array.isArray(radios)){
      return radios.map(radio => ({
        ...radio,
        id: radio.id,
        image: radio.image_base_square,
        name: radio.title,
        title: radio.title,
        dial: radio.proveedor_name,
        subType: "stvRadio",
        groupId: filterId,
      }));
    }
  }

  static async getPGMSTVRadio(radio){
    const streamType = "dvbc";
    console.log(radio);
    try {
      const pgm = await api.playerGetMedia(
        radio.id,
        null, //contentId
        false, //isTrailer
        streamType,
      );
      // TODO Quitar cuando responda con la url el servicio.
      return "tv://channel.00a0001f0003";
      return pgm.media.video_url;

    } catch (error) {
      console.log("cant get err");
      console.log(error);
    }
  };

  static getMusicDevice(){
    const platform = Device.getDevice().getPlatform();
    return (platform === 'ps4' || platform === "samsung") ? platform : 'default';
  }
}

export default MusicUtils;



// WEBPACK FOOTER //
// ./src/actions/musica/music-actions.js